<template>
  <div class="smt-container">
    <SmtQoute parentSite="smt" />
  </div>
</template>

<script>
import SmtQoute from '@@/views/smt/index'
export default {
  name: 'ordersSmt',
  components: {
    SmtQoute
  }
}
</script>

<style lang="scss" scoped>
</style>
